import React, { Component } from "react";
import {
  Row,
  Col,
  Table,
  Popconfirm,
  message,
  Button,
  Select,
} from "antd";
import { DeleteOutlined, SaveOutlined } from "@ant-design/icons";
import { withRouter } from "react-router-dom";
import PlusIcon from "../../svg/svgicon/PlusIcon";
import ButtonLinkIcon from "../../Components/MyComponent/ButtonLinkIcon";
import { API } from "../../API/API";
import UserContext from "../UserContext/UserContext";

function getDuplicates(arr, key) {
  return arr.filter((item, index, self) =>
      index !== self.findIndex((t) => (
          t[key] === item[key]
      ))
  );
}
class Settings extends Component {
  static contextType = UserContext;
  state = {
    data: [],
    actionlist: [],
    membertypelist: [],
    emplist: [],
    currentEmp: this.context.username,
  };
  componentDidMount = () => {
    this.getData();
  };
  getData = () => {
   
    API.get("/getSettings").then((response) => {
      if (response.status === 200 && response.data.retType === 0) {
        if (response.data.retData.length > 0) {
          var myData =[]
          for (let i = 0, l = response.data.retData[0].length; i < l; i++) 
          {
            let r = response.data.retData[0][i]
            let val = {};
            val = {
              'id': r['id'],
              'actionid':r['actionid'],
              'actioncode':r['actioncode'],
              'actionname':r['actionname'],
              'email':r['email'],
              'empid': r['empid'],
              'empname':r['empname'],
              'membertypeid':r['membertypeid'],
              'membertypename':r['membertypename'],
              'currentuser': this.context.username
            }
            myData.push(val);
          }
          
          this.setState({
            data: myData,
            // data: response.data.retData[0],
            actionlist: response.data.retData[1],
            membertypelist: response.data.retData[2],
            emplist: response.data.retData[3]
          });
        }
      }
    });
  };
  addRow = () => {
    let newRow = {
      id: -1 - this.state.data.length,
      actionid: 0,
      membertypeid: 0,
      empid: 0,
      currentuser: this.context.username
    };
    this.setState({
      data: [newRow, ...this.state.data],
    });
  };
  onChangeAction = (e, record) => {
    this.setState(
      this.state.data.map((item) => {
        item.actionid = item.id === record.id ? e : item.actionid;
      })
    );
  };
  onChangeMember = (e, record) => {
    console.log("change membertype=", e)
    this.setState(
      this.state.data.map((item) => {
        if (item.id === record.id)
           item.membertypeid = e;
      })
    );
    console.log("state data=", this.state.data)
  };
  onChangeEmp = (e, record) => {
    this.setState(
      this.state.data.map((item) => {
        item.empid = item.id === record.id ? e : item.empid;
      })
    );
  };
  handleDelete = (id) => {
    API.get("deleteSetting?id=" + id +"&currentuser="+ this.context.username).then((response) => {
      if (response.status === 200 && response.data.retType === 0) {
        const dataSource = [...this.state.data];
        this.setState({
          data: dataSource.filter((item) => item.id !== id),
        });
      }
    });
  };
  
  save = () => {
    let body = [...this.state.data];
    console.log("body = ", body)

    const seen = new Set();
    const duplicates = [];
  // find duplicate settings
    body.forEach(item => {
        // const identifier = `${item.actionid}|${item.empid}|${item.membertypeid}|${item.membertypename}|${item.actionname}|${item.empname}`;
        const identifier = `${item.membertypeid}|${item.actionid}|${item.empid}`;
        if (seen.has(identifier)) {
            duplicates.push(item);
        } else {
            seen.add(identifier);
        }
    });
    console.log("duplicates= ", duplicates) 
    // end find duplicate
    
    if (duplicates[0])
    {
      alert('Тохиргоо давхардсан байна. Дахин шалгана уу!');
      return false;
    } else {
      API.post("saveSettings", body).then((response) => {
        if (response.status === 200 && response.data.retType === 0) {
          message.success("Амжилттай хадгаллаа.");
          this.getData();
        }
      });
    }
  };

  render() {
    const columns = [
      {
        title: "Үйлдэл",
        dataIndex: "actionid",
        key: "actionid",
        width: "30%",
        align: "left",
        render: (text, record) => {
          return (
            <Select
              style={{ width: "100%", height: 30 }}
              showSearch
              allowClear
              optionFilterProp="name"
              onChange={(e) => this.onChangeAction(e, record)}
              defaultValue={record.actionid === 0 ? null : record.actionid}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {this.state.actionlist &&
                this.state.actionlist?.map((t, i) => (
                  <Select.Option key={i} value={t.id}>
                    {t.actionname}
                  </Select.Option>
                ))}
            </Select>
          );
        },
      },
      {
        title: "Чиг үүрэг",
        dataIndex: "membertypeid",
        key: "membertypeid",
        width: "30%",
        align: "left",
        render: (text, record) => {
          return (
            <Select
              style={{ width: "100%", height: 30 }}
              showSearch
              optionFilterProp="name"
              onChange={(e) => this.onChangeMember(e, record)}
              defaultValue={
                record.membertypeid === 0 ? null : record.membertypeid
              }
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {this.state.membertypelist &&
                this.state.membertypelist?.map((t, i) => (
                  <Select.Option key={i} value={t.membertypeid}>
                    {t.membertypename}
                  </Select.Option>
                ))}
            </Select>
          );
        },
      },
      {
        title: "Ажилтан",
        dataIndex: "empid",
        key: "empid",
        width: "30%",
        align: "left",
        render: (text, record) => {
          return (
            <Select
              style={{ width: "100%", height: 30 }}
              showSearch
              optionFilterProp="name"
              onChange={(e) => this.onChangeEmp(e, record)}
              defaultValue={record.empid === 0 ? null : record.empid}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {this.state.emplist &&
                this.state.emplist?.map((t, i) => (
                  <Select.Option key={i} value={t.empid}>
                    {t.email}
                  </Select.Option>
                ))}
            </Select>
          );
        },
      },
      {
        title: " ",
        dataIndex: "operation",
        width: "1%",
        render: (_, record) =>
          this.state.data.length > 0 ? (
            <Popconfirm
              title="Уcтгахдаа итгэлтэй байна уу?"
              onConfirm={() => this.handleDelete(record.id)}
            >
              <Button
                type="link"
                icon={<DeleteOutlined style={{ color: "red" }} />}
              />
            </Popconfirm>
          ) : null,
      },
      {
        title: "",
        dataIndex: "",
        key: "",
        width: "10%",
        align: "left",
      },
    ];

    return (
      <div className="Container">
        <Row align="middle">
          <Col span={24}>
            <Row style={{ height: 56 }} justify="start" align="middle">
              <Col>
                <div className="HeaderLabel">Эрхийн тохиргоо</div>
              </Col>
              <Col>
                <div className="divider"></div>
              </Col>
              <Col>
                <ButtonLinkIcon
                  onClick={() => this.addRow()}
                  icon={<PlusIcon />}
                  name="Мөр нэмэх"
                />
              </Col>
              <Col>
                <ButtonLinkIcon
                  onClick={() => this.save()}
                  icon={<SaveOutlined style={{ color: "#0358A7" }} />}
                  name="Хадгалах"
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <div id="tender-list" style={{ marginRight: 15 }}>
          <Table
            dataSource={this.state.data}
            columns={[
              {
                title: "№",
                dataIndex: "key",
                key: "key",
                width: "3%",
                render: (text, row, index) => (
                  <>{this.state.data.indexOf(row) + 1}</>
                ),
              },
              ...columns,
            ]}
            pagination={true}
            rowKey="id"
          />
        </div>
      </div>
    );
  }
}

export default withRouter(Settings);
